import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AgGrid from '../../shared/agGrid/agGrid.component';
import {
  runStartColumnDefinition,
  totalTimeElapsedTimeColumnDefinition,
  importTrialBalancesColumnDefinition,
  validateTrialBalancesColumnDefinition,
  calculateTaxColumnDefinition,
  runEndColumnDefinition,
} from '../../shared/columnDefinitions';

const columnDefs = [
  runStartColumnDefinition,
  totalTimeElapsedTimeColumnDefinition,
  importTrialBalancesColumnDefinition,
  validateTrialBalancesColumnDefinition,
  calculateTaxColumnDefinition,
  runEndColumnDefinition,
];

class ConnectionRunStatusGrid extends PureComponent {
  static propTypes = {
    stats: PropTypes.arrayOf(PropTypes.shape({
      runStart: PropTypes.string,
      runDuration: PropTypes.string,
      tbDuration: PropTypes.string,
      validDuration: PropTypes.string,
      calcDuration: PropTypes.string,
      runEnd: PropTypes.string,
    })),
    connectionsRunStatusLoading: PropTypes.bool.isRequired,
  };

  render() {
    const { stats, connectionsRunStatusLoading } = this.props;

    return (
      <div className="ag-grid-full-page-with-secondary-menu">
        <AgGrid
          columnDefs={columnDefs}
          rowData={stats}
          isGridLoading={connectionsRunStatusLoading}
        />
        <div>
          * Total Elapsed Time is the sum of the entire process and includes more than the sum of the 3 columns listed.
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stats: state.dashboard.connectionRunStatus.stats,
  connectionsRunStatusLoading: state.dashboard.connectionRunStatus.connectionsRunStatusLoading,
});

export default connect(mapStateToProps)(ConnectionRunStatusGrid);
